/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { type ReactElement } from 'react';
// RGBARRY-CUSTOMIZATION: Terms of Use is the internal /terms-of-use.html content asset — route it
// through the site-context Link wrapper (matches main-footer), not a hardcoded external host.
import { Link } from '@/components/link';

export default function CheckoutFooter(): ReactElement {
    return (
        <footer className="mt-auto border-t border-border">
            <div className="section-container py-4">
                <div className="flex flex-col sm:flex-row justify-between items-center gap-2 text-sm text-muted-foreground">
                    {/* RGBARRY-CUSTOMIZATION: checkout footer shows a static copyright line plus the
                        Terms of Use and Privacy Policy links. Terms of Use is an internal content asset
                        (served by the /:contentId.html route) and uses the site-context Link. The Privacy
                        Policy link targets the external TrueVault privacy center, so it stays a plain <a>. */}
                    <div>© 2026 Baggallini. All rights reserved.</div>
                    <div className="flex items-center gap-4">
                        <Link
                            to="/terms-of-use.html"
                            prefetch="none"
                            className="hover:text-foreground transition-colors">
                            Terms of use
                        </Link>
                        <a
                            href="https://privacy.baggallini.com/privacy-policy"
                            rel="noopener noreferrer"
                            className="hover:text-foreground transition-colors">
                            privacy policy
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
}
